<template>
  <div class="d-flex justify-content-center">
    <div class="row py-3">
      <div class="col-6 pr-5">
        <a class="globe-europe" href="europe" @click.prevent="goToEurope">
          <i class="fas fa-globe-europe m-auto"></i><br />
          Europe
        </a>
      </div>
      <div class="col-6">
        <a href="asia" @click.prevent="goToAsia">
          <i class="fas fa-globe-asia m-auto"></i><br />
          Asia
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "DestinationsComponent",
  methods: {
    goToEurope() {
      // Handle navigation to Europe
      this.$router.push("/europe");
    },
    goToAsia() {
      // Handle navigation to Asia
      this.$router.push("/asia");
    },
  },
};
</script>
